import { render, staticRenderFns } from "./BadgeProcess.vue?vue&type=template&id=47f1b708&scoped=true"
import script from "./BadgeProcess.vue?vue&type=script&lang=js"
export * from "./BadgeProcess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47f1b708",
  null
  
)

export default component.exports